import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import mimeTypes from "src/app/utils/mime-types";
import Swal from "sweetalert2";
import { AsignacionService } from "../asignacion.service";
import { AlertasSwalService } from "src/app/services/alerts.service";

@Component({
  selector: "app-modal-historial-asignar",
  templateUrl: "./historial.component.html",
})
export class HistorialAsignarModal implements OnInit, AfterViewInit {
  public defaults?: any = undefined;
  public actions: any[] = [
    {
      desc: "Descargar Carta de asignacion",
      action: "down",
      visible: (row) => true,
    },
  ];

  public columns: ListColumn[] = [
    {
      name: "# Control",
      property: "NoControl",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Supervisor",
      property: "Supervisor",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Chofer",
      property: "Chofer",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Fecha",
      property: "FechaCreadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  list: any[] = [];

  first = true;

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  constructor(
    public service: AsignacionService,
    public dialogRef: MatDialogRef<HistorialAsignarModal>,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alerts: AlertasSwalService
  ) {}

  public ngOnInit() {
    this.list = this.data.list;
  }

  ngAfterViewInit(): void {
    if (this.first) {
      this.tableComp.setData(this.list);
      this.first = false;
    }
  }
  actionstable(e: { action: string; row: any }) {
    if (e.action == "down") {
      this.downLoad(e.row.IdAsignacion);
    }
  }

  downLoad(e) {
    this.spinner.show();
    this.service.getCarta(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        const exist = mimeTypes[contentType];
        this.downLoadFile(response.body, contentType, "carta.pdf");
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }

  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }
}
